// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Col, Row, Table, Spinner, Alert } from 'react-bootstrap';
// import { format } from 'date-fns';
// import { BASE_URL } from "../../../../services/Api";
// import { authHeader } from "../../../../services/auth-header";

// function ViewPumpDomesticSalesEnquiry() {
//     const navigate = useNavigate();
//     const { id } = useParams();
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [data, setData] = useState({
//         enquirytype: '',
//         enquirycategory: '',
//         enquiryno: '',
//         enquirydate: '',
//         status: '',
//         customer: null,
//         contactperson: '',
//         contactno: '',
//         email: '',
//         customerMultipleAddress: null,
//         customermaterialcode: '',
//         enquiryItems: []
//     });

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await axios.get(`${BASE_URL}enquiry/findById/${id}`, {
//                     headers: authHeader()
//                 });

//                 const enquiry = response.data;
//                 setData({
//                     enquirytype: enquiry.enquirytype,
//                     enquirycategory: enquiry.enquirycategory,

//                     enquiryno: enquiry.enquiryno,
//                     enquirydate: enquiry.enquirydate,
//                     status: enquiry.status,
//                     customer: {
//                         value: enquiry.customer?.id,
//                         label: enquiry.customer?.companyname
//                     },
//                     contactperson: enquiry.contactperson,
//                     contactno: enquiry.contactno,
//                     email: enquiry.email,
//                     customerMultipleAddress: enquiry.customeraddress ? {
//                         value: enquiry.customeraddress.id,
//                         label: enquiry.customeraddress.customeraddress
//                     } : null,
//                     customermaterialcode: enquiry.customermaterialcode,
//                     enquiryItems: enquiry.enquiryItems?.map(item => ({
//                         ...item,
//                         description: item.product?.description,
//                         partno: item.product?.partno,
//                         serialnumber: item.product?.serialnumber,
//                         modelnumber: item.product?.modelnumber,
//                         tagnumber: item.product?.tagnumber,
//                         moc: item.product?.moc,
//                         hsnsacno: item.product?.hsnsacno,
//                         itemcode: item.product?.itemcode
//                     })) || []
//                 });
//             } catch (err) {
//                 setError('Failed to fetch enquiry details. Please try again.');
//                 console.error(err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [id]);

//     if (loading) {
//         return (
//             <div className="container text-center py-5">
//                 <Spinner animation="border" />
//                 <p>Loading enquiry details...</p>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="container py-5">
//                 <Alert variant="danger">{error}</Alert>
//             </div>
//         );
//     }

//     return (
//         <div className="container py-4">
//             <div className="mb-4">
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                     <p className="mb-0 me-4">
//                         <strong>Enquiry Type</strong> {data.enquirytype}
//                     </p>
//                     <p className="mb-0 me-4">
//                         <strong>Enquiry Category:</strong> {data.enquirycategory}
//                     </p>
//                 </div>

//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                     <p className="mb-0 me-4">
//                         <strong>Enquiry No:</strong> {data.enquiryno}
//                     </p>
//                     <p className="mb-0 me-4">
//                         <strong>Date:</strong> {format(new Date(data.enquirydate), 'dd/MM/yyyy')}
//                     </p>
//                     <p className="mb-0">
//                         <strong>Status:</strong> <span className={`badge bg-${data.status === 'Active' ? 'success' : 'secondary'}`}>
//                             {data.status}
//                         </span>
//                     </p>
//                 </div>

//                 <div className="card mb-4">
//                     <div className="card-header">
//                         <h5 className="mb-0">Customer Details</h5>
//                     </div>
//                     <div className="card-body">
//                         <Row>
//                             <Col md={6}>
//                                 <p><strong>Customer Name:</strong> {data.customer?.label}</p>
//                             </Col>
//                             <Col md={6}>
//                                 <p><strong>Contact Person:</strong> {data.contactperson}</p>
//                             </Col>
//                         </Row>
//                         <Row>
//                             <Col md={6}>
//                                 <p><strong>Contact Number:</strong> {data.contactno}</p>
//                             </Col>
//                             <Col md={6}>
//                                 <p><strong>Email:</strong> {data.email}</p>
//                             </Col>
//                         </Row>
//                         <Row>
//                             <Col md={6}>
//                                 <p><strong>Customer Address:</strong> {data.customerMultipleAddress?.label}</p>
//                             </Col>
//                             <Col md={6}>
//                                 <p><strong>Customer Material Code:</strong> {data.customermaterialcode}</p>
//                             </Col>
//                         </Row>
//                     </div>
//                 </div>

//                 <div className="card">
//                     <div className="card-header">
//                         <h5 className="mb-0">Enquiry Items</h5>
//                     </div>
//                     <div className="card-body">
//                         <div className="table-responsive">
//                             <Table striped bordered hover>
//                                 <thead className="table-dark">
//                                     <tr>
//                                         <th>#</th>
//                                         <th>Product Description</th>
//                                         <th>Serial No.</th>
//                                         <th>Model No.</th>
//                                         <th>Tag No.</th>
//                                         <th>Part No.</th>
//                                         <th>MOC</th>
//                                         <th>HSN Code</th>
//                                         <th>Product Code</th>
//                                         <th>Quantity</th>
//                                         <th>UOM</th>
//                                         <th>Remarks</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {data.enquiryItems.map((item, index) => (
//                                         <tr key={index}>
//                                             <td>{index + 1}</td>
//                                             <td>{item.description}</td>
//                                             <td>{item.serialnumber}</td>
//                                             <td>{item.modelnumber}</td>
//                                             <td>{item.tagnumber}</td>
//                                             <td>{item.partno}</td>
//                                             <td>{item.moc}</td>
//                                             <td>{item.hsnsacno}</td>
//                                             <td>{item.itemcode}</td>
//                                             <td>{item.quantity}</td>
//                                             <td>{item.uom}</td>
//                                             <td className="text-muted small">{item.productremarks || '-'}</td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <button className="btn btn-secondary" onClick={() => navigate(-1)}>
//                 Back
//             </button>
//         </div>
//     );
// }

// export default ViewPumpDomesticSalesEnquiry;



import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Col, Row, Table, Spinner, Badge, Container, Button } from 'react-bootstrap';
import { BASE_URL } from "../../../../services/Api";
import { authHeader } from "../../../../services/auth-header";
import { FaArrowLeft } from 'react-icons/fa';

function ViewPumpDomesticSalesEnquiry() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [data, setData] = useState({
        enquirytype: '',
        enquirycategory: '',
        enquiryno: '',
        enquirydate: '',
        status: '',
        customer: null,
        contactperson: '',
        contactno: '',
        email: '',
        customerMultipleAddress: null,
        customermaterialcode: '',
        enquiryItems: []
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}enquiry/findById/${id}`, {
                    headers: authHeader()
                });

                const enquiry = response.data;
                setData({
                    enquirytype: enquiry.enquirytype,
                    enquirycategory: enquiry.enquirycategory,
                    enquiryno: enquiry.enquiryno,
                    enquirydate: enquiry.enquirydate,
                    status: enquiry.status,
                    customer: {
                        ...enquiry.customer,
                        value: enquiry.customer?.id,
                        label: enquiry.customer?.companyname
                    },
                    contactperson: enquiry.contactperson,
                    contactno: enquiry.contactno,
                    email: enquiry.email,
                    customerMultipleAddress: enquiry.customeraddress ? {
                        value: enquiry.customeraddress.id,
                        label: enquiry.customeraddress.customeraddress,
                        city: enquiry.customeraddress.city,
                        state: enquiry.customeraddress.state,
                        pincode: enquiry.customeraddress.pincode,
                        country: enquiry.customeraddress.country
                    } : null,
                    customermaterialcode: enquiry.customermaterialcode,
                    enquiryItems: enquiry.enquiryItems?.map(item => ({
                        ...item,
                        description: item.product?.description,
                        partno: item.product?.partno || item.partno,
                        serialnumber: item.product?.serialnumber || item.serialnumber,
                        modelnumber: item.product?.modelnumber || item.modelnumber,
                        tagnumber: item.product?.tagnumber || item.tagnumber,
                        moc: item.product?.moc || item.moc,
                        hsnsacno: item.product?.hsnsacno || item.hsnsacno,
                        itemcode: item.product?.itemcode || item.itemcode,
                        uom: item.uom,
                        quantity: item.quantity,
                        productremarks: item.productremarks
                    })) || []
                });
            } catch (err) {
                setError('Failed to fetch enquiry details. Please try again.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN');
    };

    const getAddressString = (address) => {
        if (!address) return '-';
        return [
            address.label,
            address.city?.cityname,
            address.state?.statename,
            address.pincode,
            address.country?.countryname
        ].filter(Boolean).join(', ');
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'Active': return 'success';
            case 'Draft': return 'secondary';
            case 'Pending': return 'warning';
            case 'Completed': return 'success';
            case 'Cancelled': return 'danger';
            default: return 'info';
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (error) {
        return <div className="alert alert-danger text-center mt-4">{error}</div>;
    }

    return (
        <Container fluid className="p-3">
            {/* Header Section */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="fw-bold text-primary mb-0">PUMP DOMESTIC SALES ENQUIRY - VIEW</h5>
                        <div>
                            <Button variant="secondary" size="sm" onClick={() => navigate(-1)}>
                                <FaArrowLeft className="me-1" />
                                Back
                            </Button>
                        </div>
                    </div>

                    <Row className="g-2">
                        <Col md={3}>
                            <div className="border-start border-3 border-primary ps-2">
                                <small className="text-muted">Enquiry No</small>
                                <div className="fw-bold">{data.enquiryno || '-'}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-success ps-2">
                                <small className="text-muted">Enquiry Date</small>
                                <div className="fw-bold">{formatDate(data.enquirydate)}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-warning ps-2">
                                <small className="text-muted">Enquiry Type</small>
                                <div className="fw-bold">{data.enquirytype || '-'}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-info ps-2">
                                <small className="text-muted">Status</small>
                                <div>
                                    <Badge bg={getStatusBadge(data.status)} className="px-2 py-1">
                                        {data.status || '-'}
                                    </Badge>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Enquiry Details */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Enquiry Details</h6>
                </div>
                <div className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <small className="text-muted">Enquiry Category</small>
                            <div className="fw-bold">{data.enquirycategory || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Customer Material Code</small>
                            <div className="fw-bold">{data.customermaterialcode || '-'}</div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Customer Information */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Customer Information</h6>
                </div>
                <div className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <small className="text-muted">Company Name</small>
                            <div className="fw-bold">{data.customer?.companyname || data.customer?.label || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Contact Person</small>
                            <div className="fw-bold">{data.contactperson || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">GST No</small>
                            <div className="fw-bold">{data.customer?.gstno || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Phone</small>
                            <div className="fw-bold">{data.contactno || '-'}</div>
                        </Col>
                        <Col md={4}>
                            <small className="text-muted">Email</small>
                            <div className="fw-bold">{data.email || '-'}</div>
                        </Col>
                        <Col md={12}>
                            <small className="text-muted">Address</small>
                            <div className="fw-bold">{getAddressString(data.customerMultipleAddress)}</div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Enquiry Items */}
            <div className="shadow-sm border rounded bg-white mb-3">
                <div className="bg-light py-2 px-3 border-bottom">
                    <h6 className="mb-0 fw-bold">Enquiry Items</h6>
                </div>
                <div className="p-0">
                    <div className="table-responsive">
                        <Table bordered size="sm" className="mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="text-center fw-bold py-2">#</th>
                                    <th className="fw-bold py-2">Description</th>
                                    <th className="fw-bold py-2">Part No</th>
                                    <th className="fw-bold py-2">HSN Code</th>
                                    <th className="fw-bold py-2">Serial No</th>
                                    <th className="fw-bold py-2">Model No</th>
                                    <th className="fw-bold py-2">Tag No</th>
                                    <th className="fw-bold py-2">MOC</th>
                                    <th className="fw-bold py-2">Item Code</th>
                                    <th className="fw-bold py-2 text-center">Qty</th>
                                    <th className="fw-bold py-2 text-center">UOM</th>
                                    <th className="fw-bold py-2">Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.enquiryItems.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-center">{index + 1}</td>
                                        <td className="fw-semibold">{item.description || '-'}</td>
                                        <td>{item.partno || '-'}</td>
                                        <td>{item.hsnsacno || '-'}</td>
                                        <td>{item.serialnumber || '-'}</td>
                                        <td>{item.modelnumber || '-'}</td>
                                        <td>{item.tagnumber || '-'}</td>
                                        <td>{item.moc || '-'}</td>
                                        <td>{item.itemcode || '-'}</td>
                                        <td className="text-center">{item.quantity || '0'}</td>
                                        <td className="text-center">{item.uom || '-'}</td>
                                        <td>
                                            {item.productremarks && item.productremarks !== '-' ? (
                                                <small className="text-muted">{item.productremarks}</small>
                                            ) : '-'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            {/* Footer Actions */}
            <div className="text-center mt-3 pt-2 border-top">
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => navigate(-1)}
                >
                    <FaArrowLeft className="me-1" />
                    Back to List
                </Button>
            </div>
        </Container>
    );
}

export default ViewPumpDomesticSalesEnquiry;